import colors from '@/design/colors';
import { HeadingLarge } from '@/design/typography';

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 24px;
  width: 100%;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  ${HeadingLarge(16)}
  color: ${colors.blackAlpha200};
`;
